import {
  API_RESET,
  API_ERROR,
  API_SUCCESS,
  GET_DATA_INDEX,
  SET_DATA_INDEX,
  DATA_CREATE,
  GET_DATA_SHOW,
  SET_DATA_SHOW,
  DATA_EDIT,
  DATA_DELETE,
} from "./actionTypes";

const initialDataIndex = {
  dataIndex: null,
  loadingDataIndex: false,
};

const initialDataShow = {
  dataShow: null,
  loadingDataShow: false,
};

const initialAPI = {
  error: false,
  success: false,
};

const initialLoading = {
  loadingDataIndex: false,
  loadingDataShow: false,
  loadingDataCreate: false,
  loadingDataEdit: false,
  loadingDataDelete: false,
};

const initialState = { ...initialDataIndex, ...initialDataShow };

const Exceptions = (state = initialState, action) => {
  switch (action.type) {
    case API_RESET:
      state = { ...state, ...initialAPI };
      break;
    case API_ERROR:
      state = {
        ...state,
        ...initialLoading,
        error: action.payload,
        success: false,
      };
      break;
    case API_SUCCESS:
      state = {
        ...state,
        ...initialLoading,
        error: false,
        success: action.payload,
      };
      break;
    case GET_DATA_INDEX:
      state = {
        ...state,
        loadingDataIndex: true,
      };
      break;
    case SET_DATA_INDEX:
      state = {
        ...state,
        dataIndex: action.payload?.index,
        dataForm: action.payload?.form,
        loadingDataIndex: false,
      };
      break;
    case GET_DATA_SHOW:
      state = {
        ...state,
        loadingDataShow: true,
      };
      break;
    case SET_DATA_SHOW:
      state = {
        ...state,
        dataShow: action.payload?.show,
        dataForm: action.payload?.form,
        loadingDataShow: false,
      };
      break;
    case DATA_CREATE:
      state = {
        ...state,
        createData: action.payload,
        loadingDataCreate: true,
      };
      break;
    case DATA_EDIT:
      state = {
        ...state,
        editData: action.payload,
        loadingDataEdit: true,
      };
      break;
    case DATA_DELETE:
      state = {
        ...state,
        deleteData: action.payload,
        loadingDataDelete: true,
      };
      break;
    default:
      break;
  }
  return state;
};

export default Exceptions;
